import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAwoContext } from '../AwoContextProvider';
import ReportsPanel from './ReportsPanel';

function ReportsContent() {
  const { awo } = useAwoContext();

  if (awo?.preSurrenderDashboard) {
    return <Navigate to="/settings" replace />;
  }

  return <ReportsPanel />;
}

export default ReportsContent;
